/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/system-organisation.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getProcessedFieldChangeItems, getFieldChangeItems } from 'views/pages/admin/audit-log/service';

const SystemOrganisationRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        UrlPath: oldRecord.LoginCode,
        Organisation: oldRecord.Name,
        DatabaseRegion: oldRecord.Config?.MongoRegion ?? undefined,
        Config: null,
        LoginCode: null,
        Name: null,
        APIKey: null,
    };
    const refactoredNewRecord = {
        ...newRecord,
        DatabaseRegion: newRecord.Config?.MongoRegion ?? undefined,
        UrlPath: newRecord.LoginCode,
        Organisation: newRecord.Name,
        Config: null,
        LoginCode: null,
        Name: null,
        APIKey: null,
    };

    const enums: any = {
        DatabaseRegion: AuditEnumValues.Regions,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { SystemOrganisationRecordChangeGrid };
